<div class="products-overview" #productsOverview data-section-id="products-overview-section" data-section-name="Products Overview">
  <div class="products-overview__container">
    <div class="products-overview__header">
      <h2 class="products-overview__title">Beneficios de utilizar Avance y Súper Avance Unipay</h2>
    </div>

    <div class="products-overview__grid">
      <div class="products-overview__card">
        <div class="products-overview__icon-container">
          <div class="products-overview__icon-wrapper">
            <img src="https://www.unipay.cl/api/descargaArchivo/web-icon-accesorapido.png" width="64" alt="Acceso Rápido">
          </div>
        </div>
        <h3 class="products-overview__card-title">Acceso Rápido</h3>
        <p class="products-overview__card-description">Acceso rápido a efectivo para cubrir emergencias o necesidades puntuales.</p>
      </div>

      <div class="products-overview__card">
        <div class="products-overview__icon-container">
          <div class="products-overview__icon-wrapper">
            <img src="https://www.unipay.cl/api/descargaArchivo/web-icon-plazosflexibles.png" width="64" alt="Acceso Rápido">
          </div>
        </div>
        <h3 class="products-overview__card-title">Plazos Flexibles</h3>
        <p class="products-overview__card-description">Plazos de pago flexibles que se adaptan a tu capacidad financiera.</p>
      </div>

      <div class="products-overview__card">
        <div class="products-overview__icon-container">
          <div class="products-overview__icon-wrapper">
            <img src="https://www.unipay.cl/api/descargaArchivo/web-icon-procesosensillo.png" width="64" alt="Acceso Rápido">
          </div>
        </div>
        <h3 class="products-overview__card-title">Proceso Sencillo</h3>
        <p class="products-overview__card-description">Proceso de solicitud sencillo a través de múltiples canales.</p>
      </div>

      <div class="products-overview__card">
        <div class="products-overview__icon-container">
          <div class="products-overview__icon-wrapper">
            <img src="https://www.unipay.cl/api/descargaArchivo/web-icon-seguridad02.png" width="64" alt="Acceso Rápido">
          </div>
        </div>
        <h3 class="products-overview__card-title">Seguridad</h3>
        <p class="products-overview__card-description">Seguridad y confianza al contar con el respaldo de Unipay.</p>
      </div>
    </div>
  </div>
</div>
